// extracted by mini-css-extract-plugin
export var checked = "form-ricerca-module--checked--a268e";
export var form = "form-ricerca-module--form--4c5a4";
export var formApc = "form-ricerca-module--form-apc--a7734";
export var formBanca = "form-ricerca-module--form-banca--4deb0";
export var formRicerca = "form-ricerca-module--formRicerca--37845";
export var hideMobile = "form-ricerca-module--hide-mobile--4e2d1";
export var labelNotUppercase = "form-ricerca-module--labelNotUppercase--cbfb8";
export var labelUnderButton = "form-ricerca-module--label-under-button--f3555";
export var loadingOverlay = "form-ricerca-module--loadingOverlay--ae203";
export var mobileBg = "form-ricerca-module--mobile-bg--9285d";
export var submitWrapper = "form-ricerca-module--submitWrapper--a9339";
export var text = "form-ricerca-module--text--7e9fc";
export var unchecked = "form-ricerca-module--unchecked--04e87";